import React, { useContext, useEffect, useState } from 'react';
import { EditCustomerContext, IEditCustomerContext } from '../../../../editCustomerState/editCustomerContext';
import { ILocalizationContext, LocalizationContext } from '../localizationState/localizationContext';
import { ICustomerLanguage } from 'types';
import { switchArrayItems } from 'utils/helpers';
import { LanguageBarItemNew } from 'components/LanguageBarItem/LanguageBarItemNew';

interface IProps {
	items: ICustomerLanguage[];
}

export const LanguageBar: React.FC<IProps> = ({ items }) => {
	const { setLanguage, selectedLanguage } = useContext<ILocalizationContext>(LocalizationContext);
	const { IDSelectedCustomerDefaultLanguage } = useContext<IEditCustomerContext>(EditCustomerContext);
	const [orderedLanguages, setOrderedLanguages] = useState<ICustomerLanguage[]>([]);

	useEffect(() => {
		const indexOfDefaultLanguage = items.findIndex((el) => el.languageId === IDSelectedCustomerDefaultLanguage);
		const orderedByDefaultLanguage = switchArrayItems(items, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [items, IDSelectedCustomerDefaultLanguage]);

	useEffect(() => {
		const initialLanguage = orderedLanguages.length
			? { id: orderedLanguages[0].languageId, name: orderedLanguages[0].languageName }
			: null;
		setLanguage(selectedLanguage ? selectedLanguage : initialLanguage);
	}, [selectedLanguage, orderedLanguages]);

	return orderedLanguages.length ? (
		<div className="flex flex-wrap gap-4" data-test="LanguageBar">
			{orderedLanguages.map((el) => (
				<LanguageBarItemNew
					key={el.languageId}
					languageId={el.languageId}
					isActive={selectedLanguage?.id === el.languageId}
					onClick={() => setLanguage({ id: el.languageId, name: el.languageName })}
				/>
			))}
		</div>
	) : null;
};
